import axios from 'axios';


// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.

   const axiosInstance =  axios.create({
      //  baseURL: process.env.VUE_APP_baseUrl,
        baseURL: 'https://localhost:5001',
        timeout: 360000
    });

        

    const requestHandler = request => {
            // Token will be dynamic so we can use any app-specific way to always   
            // fetch the new token before making the call
            // first try localstorage
            let token;
        
            
            //onst _store = require('@/store/index.js');
       token = window.vm.$store.getters['authModule/api_idtoken'];
           // token = app.$store.default.getters['authModule/api_idtoken'];
            
       if ( token == undefined || token == null){
               // try to silently acquire a new token
               //console.log("[customAxios.js] No Id Token - Need to get new one");
               //let newusr = auth.user();
               //console.log(`customAxios called auth.js to get a new token: ${newusr}`)
             
               //token = auth.acquireIdToken();
               //localStorageService.setIdToken(token);
                throw new Error('no token');
        
            } 
            request.headers.Authorization = `Bearer ${token}`;  
            return request;
        }
        
    const responseHandler = response => {
            if (response.status === 401) {
                window.location = '/login';
            }
        
            return response;
     };
        
        const errorHandler = error => {
            return Promise.reject(error);
        };
        

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
axiosInstance.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

axiosInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
 );

      
  


export default axiosInstance;
// Step-4: Export the newly created Axios instance to be used in different locations.
